import { inject } from '@angular/core';
import { catchError, of, switchMap } from 'rxjs';
import { AuthService } from './auth.service';
import { injectGuardDenials } from './guard-denials';

/** UX gate: the backend's `canImpersonate` capability. Backend remains the authority. */
export function canStartImpersonationGuard() {
  return () => {
    const authService = inject(AuthService);
    const deny = injectGuardDenials();

    return authService.authenticate().pipe(
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return of(false);
        }
        return authService.ensureUserAccessLoaded$().pipe(
          switchMap(() => (authService.canStartImpersonation() ? of(true) : deny.noPermission$())),
          catchError((error: unknown) => deny.accountLoadFailed$(error))
        );
      })
    );
  };
}
